import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CloseCrossIcon } from 'assets/iconButtons/close-cross.svg';
import i18nContext from 'components/i18n-context';

/**
 * Title + subtitle + close (✕) row used by the code-entry modals (Sms.js — covers every
 * TWO_FACTOR_AUTH_TYPES value — and PopUpInternalActionConfirmationScheme; see ConfirmationModal.js
 * for why this isn't baked into the shell itself). Not used by SwitchConfirmationMethodScreen,
 * whose Figma frame has a different header (centered title only, no close icon — dismissal is its
 * own "Close" footer button instead).
 */
export const ConfirmationModalHeader = ({ title, subtitle, onClose }) => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'confirmation-modal__header'}>
      <div className={'confirmation-modal__header-text'}>
        <h2 className={'confirmation-modal__title'}>{title}</h2>
        {subtitle && <p className={'confirmation-modal__subtitle'}>{subtitle}</p>}
      </div>
      {onClose && (
        <button
          type={'button'}
          className={'confirmation-modal__close'}
          onClick={onClose}
          aria-label={i18n.getMessage('confirmationModal.ariaLabel.close')}
        >
          <CloseCrossIcon />
        </button>
      )}
    </div>
  );
};

ConfirmationModalHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  onClose: PropTypes.func
};
